import "./Avatar.scss";
import {
  MemberDto,
  MemberDtoInvitationStatusEnum,
} from "../../generated/account-client";
import { UserOutlined } from "@ant-design/icons";

export interface AvatarProps {
  member?: MemberDto;
}

function getInitials(name: string | undefined): string | null {
  if (!name || !name.trim() || name.indexOf(" ") === -1) return null;

  let bits = name.split(/\s+/);
  bits = bits.filter(b => b !== "");
  return `${bits[0][0]}${bits[1][0]}`.toUpperCase();
}

export default function Avatar({ member }: AvatarProps) {
  const initials = getInitials(member?.name);
  return (
    <div className={"avatar user-avatar"}>
      {member?.invitationStatus === MemberDtoInvitationStatusEnum.Active &&
        (initials ? <h2>{initials}</h2> : <UserOutlined />)}
      {member?.invitationStatus !== MemberDtoInvitationStatusEnum.Active && (
        <UserOutlined />
      )}
    </div>
  );
}
